import useRoleOptions from "ui/user/query/useRoleOptions";
import { SelectOption } from "@commonlibs";
import RoleSelectLabel from "ui/role/components/input/RoleSelect/RoleSelectLabel/RoleSelectLabel";
import { useMemo } from "react";
import { getRoleMapKey, RoleMap } from "ui/role/utils/roleMap";

export interface UseRoleSelectOptionsReturn {
    options: SelectOption<string>[] | undefined;
    roleMap: RoleMap;
}

export default function useRoleSelectOptions(): UseRoleSelectOptionsReturn {
    const { data: options } = useRoleOptions();

    return useMemo(() => {
        const roleMap: RoleMap = {};
        const selectOptions: SelectOption<string>[] | undefined = [];
        options?.forEach((option) => {
            const key = getRoleMapKey(option);
            roleMap[key] = option;
            selectOptions.push({
                value: key,
                label: <RoleSelectLabel role={option} />,
            });
        });
        return { roleMap, options: selectOptions };
    }, [options]);
}
